export const Category = {
  photo: {
    type: 'Image',
  },
  video: {
    type: ['Video', 'Live Video'],
  },
};
